import { Box, Button, Container } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { HeaderWithActions, InitializationWrapper } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import { Helmet } from 'react-helmet-async'
import { BerthPlanningViewWrapper } from '../BerthPlanning/BerthPlanningViewWrapper'
import { ViewToggleButtons } from './Components/atoms/ViewToggleButtons'
import { VesselVisitTable } from './Components/VesselVisitTable'
import { VesselVisitsViewStore } from './Stores/VesselVisitViewStore'

export const VesselVisitsPage = observer(() => {
  const navigate = useNavigate()
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { vesselVisitItemStore } = usePlanningStore()

  const store = useMemo(
    () => new VesselVisitsViewStore(vesselVisitItemStore),
    [vesselVisitItemStore],
  )

  const { loading } = useAsyncFetch(async () => {
    await store.fetchVisits()
  }, [store])

  const title = t('vesselVisits', 'Vessel visits')

  return (
    <InitializationWrapper isInitializing={loading || store.isLoading}>
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100vh' }}>
        <Helmet>
          <title>{t('vesselVisits', 'Vessel visits')}</title>
        </Helmet>
        <HeaderWithActions
          title={title}
          noMarginBottom
          actions={[
            <Button
              key='create'
              variant='contained'
              data-cy='create-vessel-visit-btn'
              onClick={() =>
                navigate(PATHS.visits.vesselPlanning.url, {
                  state: { from: 'vessel-visits' },
                })
              }
            >
              {t('createVisit', 'Create visit')}
            </Button>,
          ]}
        />
        <Container sx={{ paddingY: 2 }}>
          {store.viewType === 'plan' ? (
            <BerthPlanningViewWrapper
              headerActions={
                <ViewToggleButtons
                  currentView={store.viewType}
                  onListClick={() => store.setViewType('list')}
                  onPlanClick={() => store.setViewType('plan')}
                />
              }
            />
          ) : (
            <VesselVisitTable
              data={store.vesselVisitTableDtos}
              renderTableCustomActions={() => (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <ViewToggleButtons
                    currentView={store.viewType}
                    onListClick={() => store.setViewType('list')}
                    onPlanClick={() => store.setViewType('plan')}
                  />
                </Box>
              )}
            />
          )}
        </Container>
      </Box>
    </InitializationWrapper>
  )
})
